export default "__VITE_ASSET__Cwt73G7C__"